import { CancelButton } from './CancelButton'
import { CompleteButton } from './CompleteButton'
import { StyledRecorderButtonRow } from './RecorderButtonRow.styles'
import type { ResumePauseButtonProps } from './ResumePauseButton'
import { ResumePauseButton } from './ResumePauseButton'

export interface RecorderButtonRowProps extends ResumePauseButtonProps {
  onCancel: () => void
  onComplete: () => void
}

export function RecorderButtonRow(props: RecorderButtonRowProps): JSX.Element {
  return (
    <StyledRecorderButtonRow>
      <CancelButton onClick={props.onCancel} />
      <CompleteButton onClick={props.onComplete} />
      <ResumePauseButton
        state={props.state}
        onPause={props.onPause}
        onResume={props.onResume}
      />
    </StyledRecorderButtonRow>
  )
}
